import React, { useEffect, useState } from 'react';

const LogoSplash = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = '/Images/Logo1.png'; // ✅ Use path relative to public folder
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  return (
    <>
      <style>{`
        .splash-container {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          background: #fff;
          perspective: 600px;
          padding: 20px;
          box-sizing: border-box;
        }

        .loader-wrapper {
          position: relative;
          width: 300px;
          height: 300px;
        }

        .loader-ring {
          box-sizing: border-box;
          position: absolute;
          inset: 0;
          border-radius: 25%;
          border: 3px solid transparent;
          filter: drop-shadow(0 3px 6px rgba(0,0,0,0.15));
          background: radial-gradient(circle at center, #eaf3fc 0%, transparent 70%);
          animation-timing-function: linear;
          transform-style: preserve-3d;
        }

        .loader-ring:nth-child(1) {
          border-top-color: rgb(14, 23, 104);
          border-left-color: transparent;
          border-bottom-color: #16a085;
          animation: spinClockwise 2s linear infinite;
          box-shadow:
            0 0 10px #1abc9c,
            inset 0 0 20px #16a085;
        }

        .logo-center {
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 250px;
          height: 200px;
          transform: translate(-50%, -50%) scale(0.8);
          border-radius: 30%;
          overflow: visible;
          background: white;
          padding: 12px;
          opacity: 0;
          transition: transform 0.6s ease, opacity 0.6s ease;
        }

        .logo-center.loaded {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
        }

        .logo-center:hover {
          transform: translate(-50%, -50%) scale(1.05);
        }

        @keyframes spinClockwise {
          0% { transform: rotateX(20deg) rotateZ(0deg) scale(1); }
          50% { transform: rotateX(20deg) rotateZ(180deg) scale(1.05); }
          100% { transform: rotateX(20deg) rotateZ(360deg) scale(1); }
        }
      `}</style>

      <div className="splash-container">
        <div className="loader-wrapper">
          <div className="loader-ring" />
          <img
            src="/Images/Logo1.png" // ✅ Direct path from public folder
            alt="Company Logo"
            className={`logo-center ${imageLoaded ? 'loaded' : ''}`}
          />
        </div>
      </div>
    </>
  );
};

export default LogoSplash;
